import React from 'react';
import { OfficialDailyDetailProvider } from './context/official-daily-detail-context';
import { OfficialDailyDetailComponent } from './official-daily-detail-component';
import { BaseLayoutFactory } from '../global/base-layout-factory';

export function OfficialDailyDetailFactory() {
    return (
        <BaseLayoutFactory>
            <OfficialDailyDetailProvider>
                <OfficialDailyDetailComponent />
            </OfficialDailyDetailProvider>
        </BaseLayoutFactory>
    );
}
